/**
 * Parse the text of a `TimeField` (2026-10b §3.8) into a wall minute of day (0-1439), or null
 * when the text is not a time. Normalisation first: full-width digits become half-width; the
 * full-width colon "：", the stops "。", "．" and the half-width "." become ":"; spaces are
 * ignored. Accepted forms: "13:35", "1335", "13.35", "9" (09:00), "930" (09:30), "9:5"
 * (a single digit after the colon is the minute unit: 09:05).
 */
export function parseWallTimeText(raw: string): number | null {
  const text = raw
    .replace(/[０-９]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) - 0xff10 + 0x30))
    .replace(/[：。．.]/g, ':')
    .replace(/[\s\u3000]+/g, '');
  if (text === '') return null;
  const withColon = /^(\d{1,2}):(\d{1,2})$/.exec(text);
  if (withColon !== null) {
    const hours = Number(withColon[1]);
    const minutes = Number(withColon[2]);
    if (hours > 23 || minutes > 59) return null;
    return hours * 60 + minutes;
  }
  if (!/^\d{1,4}$/.test(text)) return null;
  const hours = text.length <= 2 ? Number(text) : Number(text.slice(0, text.length - 2));
  const minutes = text.length <= 2 ? 0 : Number(text.slice(-2));
  if (hours > 23 || minutes > 59) return null;
  return hours * 60 + minutes;
}
